<template>
  <div class="text-center">
    <!-- <transition name="fade">

    </transition> -->
    <h4 v-for="(quote, index) in quotes" v-if="currentIndex === index" v-bind:key="'quote' + index" class="quotes">{{quote}}</h4>
  </div>
</template>

<script>

export default {
  data () {
    return {
      quotes: [
        'Everything begins with an idea.',
        'There are no bad ideas, just bad decisions.',
        'What leads the world are not machines, but ideas.',
        'Every really new idea looks crazy at first.'
      ],
      currentIndex: 0
    }
  },
  created () {
    var self = this
    setInterval(function () {
      self.currentIndex++
      if (self.currentIndex === 4) {
        self.currentIndex = 0
      }
    }, 4000)
  }
}
</script>

<style>
  .quotes {
    color: #00508f;
    font-weight: 300;
  }
</style>



// WEBPACK FOOTER //
// src/components/TextSlider.vue